import { createAction, createSlice } from '@reduxjs/toolkit';
import { HYDRATE } from 'next-redux-wrapper';

import {
  LeadMagnetFormCaseReducers,
  LeadMagnetFormCaseSelectors,
  LeadMagnetFormState
} from './types';

const hydrateAction = createAction<{
  leadMagnetForm: LeadMagnetFormState;
}>(HYDRATE);

const initialState: LeadMagnetFormState = {
  isModalOpen: false,
  loading: false,
  profile: 'buyer',
  sent: false
};

const leadMagnetFormSlice = createSlice<
  LeadMagnetFormState,
  LeadMagnetFormCaseReducers,
  'leadMagnetForm',
  LeadMagnetFormCaseSelectors
>({
  name: 'leadMagnetForm',
  initialState,
  reducers: {
    send: (state) => {
      state.error = undefined;
      state.loading = true;
    },
    sendError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.isModalOpen = true;
    },
    sendSuccess: (state) => {
      state.loading = false;
      state.sent = true;
      state.isModalOpen = true;
    },
    setProfile: (state, action) => {
      state.profile = action.payload;
    },
    setLoading: (state, action) => {
      state.error = undefined;
      state.loading = action.payload;
    },
    setIsModalOpen: (state, action) => {
      state.isModalOpen = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(hydrateAction, (state, action) => {
      return {
        ...state,
        ...action.payload.leadMagnetForm
      };
    });
  }
});

export * from './types';

export const {
  send,
  sendError,
  sendSuccess,
  setIsModalOpen,
  setLoading,
  setProfile
} = leadMagnetFormSlice.actions;

export default leadMagnetFormSlice.reducer;
